// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Author page sections

import Beneficios from "./sections/beneficios/Posts";
import FormularioVoucher from "./sections/FormularioVoucher/FormularioVoucher";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";

// Routes
import routes from "routes";
import { Helmet } from "react-helmet-async";

export default function BeneficiosAfiliadosPage() {
  return (
    <>
      <Helmet>
        <title>Beneficios para Afiliados | Sindicato Panaderos San Juan</title>

        <meta
          name="description"
          content="Descubrí todos los beneficios de estar afiliado: descuentos en farmacias, ortopedia, estética, camping, cabañas en Rodeo, útiles escolares y cajas navideñas."
        />

        <meta
          name="keywords"
          content="beneficios panaderos san juan, descuentos farmacia amparo, camping el paraiso san juan, cabañas rodeo descuentos, subsidios panaderos, sindicato panaderos beneficios"
        />

        {/* Open Graph para redes sociales */}
        <meta property="og:title" content="Beneficios Exclusivos - Sindicato Panaderos San Juan" />
        <meta
          property="og:description"
          content="Aprovechá los descuentos en farmacias, recreación, salud y estética para vos y tu familia."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/blogs/31115/images/b0qlzF7SuOWwSVzq6Kiy_Atraer-clientes-a-tu-farmacia-1080x675.jpg"
        />

        <link rel="canonical" href="http://sindicatopanaderossanjuan.com.ar/beneficiosafiliados" />
      </Helmet>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />
      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url("https://i.pinimg.com/736x/4c/49/2b/4c492bde8bfa924986e22ceb27ccad14.jpg?format=auto")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Beneficios />
        </Card>
        <FormularioVoucher />
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}
